import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { CustomerResource } from '../customer.resource';
import { CustomerFactory } from 'app/resources/factories/customer.factory';
import { AuthenticationInfo } from '../models/authentication-info.model';
import { Customer } from '../models/customer.model';
import { AuthenticationService } from './authentication.service';
import * as _ from 'lodash';

@Injectable()
export class CustomerService {
  private _customers: BehaviorSubject<Customer[]>;
  public get customers(): Observable<Customer[]> {
    return this._customers.skipWhile(customers => customers === undefined).take(1);
  }
  private isConsoleAdmin: boolean;

  public constructor(
    private authService: AuthenticationService,
    private customerResource: CustomerResource,
    private customerFactory: CustomerFactory,
  ) {
    this._customers = new BehaviorSubject<Customer[]>(undefined);
    this.isConsoleAdmin = false;
    this.authService.authenticationInfo.subscribe((authenticationInfo: AuthenticationInfo) => {
      if (authenticationInfo.user === null) {
        this._customers.next([]);
      } else {
        if (_.find(authenticationInfo.user.roles, { name: 'Console Admin' })) {
          this.isConsoleAdmin = true;
          this.fetchAllCustomers();
        } else {
          this._customers.next(authenticationInfo.user.customers.map(c => this.customerFactory.toModel(c) as Customer));
        }
      }
    });
  }

  public hasCustomer(customer: number | string): Observable<boolean> {
    if (typeof customer === 'string') {
      return this.hasCustomerByName(customer);
    } else {
      return this.hasCustomerById(customer);
    }
  }

  public customerByName(customerName: string): Observable<Customer> {
    return this.customers
      .map((customers: Customer[]) => {
        return _.find(customers, { name: customerName }) || null;
      });
  }

  public customerExists(customer: number | string): Observable<boolean> {
    if (typeof customer === 'string') {
      return this.customerExistsByName(customer);
    } else {
      return this.customerExistsById(customer);
    }
  }

  private hasCustomerByName(customerName: string): Observable<boolean> {
    return this.customers
      .map((customers: Customer[]) => {
        if (this.isConsoleAdmin) {
          return true;
        } else {
          return !!_.find(customers, { name: customerName });
        }
      });
  }

  private hasCustomerById(customerId: number): Observable<boolean> {
    return this.customers
      .map((customers: Customer[]) => {
        if (this.isConsoleAdmin) {
          return true;
        } else {
          return !!_.find(customers, { id: customerId });
        }
      });
  }

  private customerExistsByName(customerName: string): Observable<boolean> {
    return this.customers
      .pipe(map((customers: Customer[]) => {
        return !!_.find(customers, { name: customerName });
      }));
  }

  private customerExistsById(customerId: number): Observable<boolean> {
    return this.customers
      .pipe(map((customers: Customer[]) => {
        return !!_.find(customers, { id: customerId });
      }));
  }

  private fetchAllCustomers(): void {
    this.customerResource.findAll()
      .subscribe((customers: Customer[]) => {
        this._customers.next(customers);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/auth/customer.service.ts